/**
 * Resolves a raw S3 URL to a short-lived signed URL so the browser
 * can load it without CORS / 403 errors.
 *
 * If the URL is not a recognised S3 URL it is returned unchanged.
 */
export async function getSignedS3Url(s3Url: string): Promise<string> {
  const s3Match = s3Url.match(/^https?:\/\/([^/]+)\.s3(?:\.([^/.]+))?\.amazonaws\.com\/([^?]+)/);
  if (!s3Match) return s3Url;

  const { getSignedUrl } = await import("graphQL/query/file");
  const bucket = s3Match[1];
  const region = s3Match[2] || "ap-southeast-2";
  const key = decodeURIComponent(s3Match[3]);
  const signed = await getSignedUrl(bucket, key, "GET", region);
  if (!signed || typeof signed !== "string") {
    throw new Error(`Failed to sign S3 URL: ${signed}`);
  }
  return signed;
}
